/**
 * L2-S5: moved to @miq/platform-ui (lib/components/tree-data-table/commands/commands.component.ts).
 * This shim keeps the old import path working; new code should import from '@miq/platform-ui'.
 */
export { CommandsComponent } from '@miq/platform-ui';
